// extracted by mini-css-extract-plugin
export default {"iconslide":"Specifications_iconslide__A3UhZ","specBackground":"Specifications_specBackground__gDFzq"};